import { useEffect, useState } from 'react';
import { useClientSettings } from '../client-pwa/settings';

const SPLASH_KEY = 'client-pwa-v3-splash-shown';

export default function SplashV3() {
  const { themeMode } = useClientSettings();
  const [visible, setVisible] = useState(() => {
    try { return sessionStorage.getItem(SPLASH_KEY) !== '1'; } catch { return true; }
  });

  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => dismiss(), 2400);
    return () => clearTimeout(timer);
  }, [visible]);

  const dismiss = () => {
    try { sessionStorage.setItem(SPLASH_KEY, '1'); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      onClick={dismiss}
      className="fixed inset-0 z-[100] flex flex-col items-center justify-between bg-stone-50 dark:bg-stone-950 px-8 pb-12 pt-20 animate-in fade-in duration-500"
      style={{
        backgroundImage: themeMode === 'dark'
          ? 'radial-gradient(rgba(255,255,255,0.05) 1px, transparent 1px)'
          : 'radial-gradient(rgba(0,0,0,0.04) 1px, transparent 1px)',
        backgroundSize: '24px 24px',
      }}
    >
      <div className="flex flex-1 flex-col items-center justify-center text-center">
        {/* Wordmark / monogram */}
        <div className="flex h-20 w-20 items-center justify-center border-2 border-stone-900 dark:border-stone-100 bg-stone-900 dark:bg-stone-100 text-2xl font-bold tracking-widest text-stone-50">
          VA
        </div>

        <p className="mt-8 text-[12px] font-bold uppercase tracking-[0.4em] text-stone-500">
          Beacon Accounting · Est. 2008
        </p>

        <div className="mt-6 w-full max-w-xs">
          <div className="border-t border-stone-300 dark:border-stone-700" />
          <div className="my-3">
            <p className="text-[11px] uppercase tracking-[0.3em] text-stone-500">Prepared for</p>
            <h1 className="mt-2 font-serif text-3xl font-bold leading-tight tracking-tight text-stone-900 dark:text-stone-100">
              James Tiling
            </h1>
            <p className="mt-1 text-xs text-stone-600 dark:text-stone-400">Pty Ltd · ACN 624 587 192</p>
          </div>
          <div className="border-t border-stone-300 dark:border-stone-700" />
        </div>

        <div className="mt-8 flex items-center gap-2 text-[12px] uppercase tracking-[0.25em] text-stone-500">
          <span className="h-1 w-1 animate-pulse rounded-full bg-teal-700 dark:bg-teal-500" />
          <span>Loading your records</span>
        </div>
      </div>

      <div className="flex flex-col items-center gap-1">
        <p className="font-serif text-[12px] italic text-stone-400 dark:text-stone-500">
          A digital ledger
        </p>
        <p className="text-[11px] uppercase tracking-[0.3em] text-stone-400 dark:text-stone-500">
          Powered by <span className="font-bold text-stone-700 dark:text-stone-300">RoniDoc</span>
        </p>
      </div>
    </div>
  );
}
